import { render } from "./bookCreate.vue?vue&type=template&id=6db5f24c"
import script from "./bookCreate.vue?vue&type=script&lang=js"
export * from "./bookCreate.vue?vue&type=script&lang=js"

import "./bookCreate.vue?vue&type=style&index=0&id=6db5f24c&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__